import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from 'utils/constants';
import styles from '../Membership.module.scss';

function RollbackMembership() {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.title}>Rollback membership</h1>
      </header>
      <div className={styles.emptyState}>
        <p>
          Rollback membership from the{' '}
          <Link to={ROUTES.MEMBERSHIP.ROOT}>membership list</Link> by selecting
          a membership.
        </p>
      </div>
    </div>
  );
}

export default RollbackMembership;
